import React from "react";
import { CheckIcon } from "lucide-react";
import { audience } from "../data/landing";
export function AudienceSection() {
  return <section id="para-quien" className="scroll-mt-20 border-b border-line" data-id="element-14" data-mp="mzx4o3sdofxu">
      <div className="mx-auto max-w-6xl px-6 py-20 md:py-28" data-id="element-15" data-mp="s1mghlnfcxmz">
        <h2 className="max-w-2xl font-serif text-4xl leading-tight text-cream md:text-5xl" data-id="element-16" data-mp="wznwfxpk0gu8">
          Este ebook fue creado para vos si…
        </h2>
        <ul className="mt-12 grid gap-x-12 md:grid-cols-2" data-id="element-17" data-mp="3vimluepxyu71">
          {audience.map(item => <li key={item} className="flex gap-4 border-t border-line py-5" data-id="element-18" data-mp="4bs22zngj10m">
              <CheckIcon className="mt-0.5 h-5 w-5 flex-none text-gold" aria-hidden="true" data-id="element-19" data-mp="99tkrjgz0ybk" />
              <span className="leading-relaxed text-cream" data-id="element-20" data-mp="e13bkne9a7p1">{item}</span>
            </li>)}
        </ul>
        <p className="mt-10 max-w-3xl font-serif text-xl italic leading-relaxed text-cream/90" data-id="element-21" data-mp="3cpsf282h28dw">
          Para personas que no quieren esperar a que “el país se calme” para empezar a construir
          una vida más clara, próspera y consciente.
        </p>
      </div>
    </section>;
}